import { React, useState, useEffect } from "react";

import { useLocation, useParams } from "react-router-dom";

import { getClass, getStudents } from "../services/APIClient";

import HeadingBanner from "../components/HeadingBanner";
import LeftPanel from "../components/LeftPanel";
import AllStudentResultsOverview from "../components/AllStudentResultsOverview";
import OrientationPrompt from "../components/OrientationPrompt";
import AllStudentReportCardsOverview from "../components/AllStudentReportCardsOverview";

import { Container, Row, Col } from "react-bootstrap";

function AllStudentReportCards(props) {
  const location = useLocation();

  console.log(location.state, "LOCATION");

  let name = "Results";

  let classDetails = location.state.classDetails;
  let classid = location.state.classDetails.id;

  let gradeLevel = location.state.gradeLevel;
  let classAssessments = location.state.classAssessments;
  // let teacherid = location.state.classDetails.classDetails.teacherId;
  let teachers = location.state.teachers;
  let assessment = location.state.assessment;
  let studentResults = location.state.studentResults;

  let taskNameArray = location.state.taskNameArray;
  let assessmentResultsByStudent = location.state.assessmentResultsByStudent;
  let toggleScoreType = location.state.toggleScoreType;

  let schoolid = location.state?.schoolid;
  let teacherid = location.state?.teacherid;
  let students = location.state?.students;

  console.log("LOCATION:", location.state);
  console.log("schoolid:", schoolid);

  const [isPortrait, setIsPortrait] = useState(
    window.matchMedia("(orientation: portrait)").matches
  );

  // useEffect(() => {
  //   window.HubSpotConversations?.widget?.refresh();
  // }, []);

  useEffect(() => {
    const handleOrientationChange = () => {
      setIsPortrait(window.innerWidth < window.innerHeight);
    };

    window.addEventListener("resize", handleOrientationChange);

    return () => {
      window.removeEventListener("resize", handleOrientationChange);
    };
  }, []);

  // useEffect(() => {
  //   window.HubSpotConversations?.widget?.refresh();
  // }, []);

  return (
    <Container fluid className="vh-100">
      <HeadingBanner
        name={name}
        isLoggedIn={true}
        cloud={true}
        teacherid={teacherid}
      />
      <Row className="h-100">
        <LeftPanel />
        <Col sm={{ span: 10, offset: 2 }} className="blue-background">
          <AllStudentReportCardsOverview
            classDetails={classDetails}
            classAssessments={classAssessments}
            // teachers={location.state.teachers}
            // sharedWith={sharedWith}
            students={students}
            gradeLevel={gradeLevel}
            teachers={teachers}
            assessment={assessment}
            studentResults={studentResults}
            taskNameArray={taskNameArray}
            assessmentResultsByStudent={assessmentResultsByStudent}
            toggleScoreType={toggleScoreType}
            schoolid={schoolid}
            teacherid={teacherid}
          />
        </Col>
      </Row>
      {isPortrait && <OrientationPrompt />}
    </Container>
  );
}

export default AllStudentReportCards;
